import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { MemoizedPageLoader } from "@/components";
import { payxpress_png_logo } from "@/assets";
import { getThemeConfig } from "@/lib";
import { Suspense } from "react";
import { publicRoutes } from "./public";
import { privateRoutes } from "./private";
import { ConfigProvider } from "antd";
import { CookiesSettings } from "@/components/Cookies/CookiesSettings";

export const AppRoutes = () => {
  const router = createBrowserRouter([...publicRoutes, ...privateRoutes]);
  return (
    <ConfigProvider theme={getThemeConfig()}>
      <Suspense
        fallback={
          <div className="flex justify-center items-center h-screen overflow-hidden">
            <MemoizedPageLoader
              image={payxpress_png_logo}
              className="w-[150px]"
            />
          </div>
        }
      >
        <RouterProvider router={router} />
        <CookiesSettings />
      </Suspense>
    </ConfigProvider>
  );
};
